<!-- <div class="container-fluid mt-3 mb-3">
    <div class="row justify-content-center ">
        <ng-container *ngFor="let derivative of user?.menusList">
            <div class="card col-lg-3 mr-5 colorborder mt-5">
                <div class="card-header">
                    <h3>{{derivative.menuName}}</h3>
                </div>
                <div class="card-body">
                    <div *ngFor="let data of derivative?.userMenusImpls">
                        <a [routerLink]="'/'+derivative.menuCode+'/'+data.menuCode"
                            [ngClass]="(data.isAccessAllowed=='N' || data.isActive=='N')?'disabled':''">{{data.menuName}}</a>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>


</div> -->
<div class="container-fluid mt-3 mb-2 ml-1">
    <!-- <div class="carausel slide" id="myCarousel">
        <div class="carousel-inner d-flex justify-content-center ">
            <button *ngIf="user?.menusList.length > itemsPerPage" (click)="previous()"
                    [disabled]="currentIndex ===0" class="btn btn-sm mr-5">&#10094;</button>
            <ng-container *ngFor="let derivative of  user?.menusList;let i=index">
                <div class="item" [ngClass]="i==0?'active':''">
                    <div class="card col-lg-3 col-md-4 col-sm-6 card-container mt shadow1 p-2 ">
                        <img src='{{"assets/images/"+derivative.menuCode+".png"}}' alt="Avatar" class="image m-auto">
                        <h3 class="text-center">{{derivative.menuName}}</h3>
                        <div class="overlay mt card" *ngIf="derivative?.userMenusImpls?.length> 0">
                            <div class="card card-header">
                                <h3 class="text-center">{{derivative.menuName}}</h3>
                            </div>
                            <div *ngFor="let data of derivative?.userMenusImpls">
                                <a [routerLink]="'/'+derivative.menuCode+'/'+data.menuCode"
                                    [ngClass]="(data.isAccessAllowed=='N' || data.isActive=='N')?'disabled':''">{{data.menuName}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <button *ngIf="user?.menusList.length > itemsPerPage" (click)="next()"
                    [disabled]="currentIndex >= user?.menusList.length - itemsPerPage"
                    class="btn btn-sm mr-5">&#10095;</button>
        </div>
    </div> -->
    <div class="col-lg-12">
        <carousel [interval]="0" itemsPerSlide="{{itemsPerSlide}}" [noWrap]="true" [singleSlideOffset]="true" [showIndicators]="true"
            [indicatorsByChunk]="true">
            <slide *ngFor="let derivative of  user?.menusList; let index=index"
                class="card card-container mt shadow1 p-2 mr-2 ml-2 animated fadeIn">
                <img src='{{"assets/images/"+derivative.menuCode+".png"}}' alt="image slide" class="image m-auto">
                <h3 class="text-center">{{derivative.menuName}}</h3>
                <div class="overlay mt card" *ngIf="derivative?.userMenusImpls?.length> 0">
                    <div class="card card-header">
                        <h3 class="text-center">{{derivative.menuName}}</h3>
                    </div>
                    <div *ngFor="let data of derivative?.userMenusImpls">
                        <a [routerLink]="'/'+derivative.menuCode+'/'+data.menuCode"
                            [ngClass]="(data.isAccessAllowed=='N' || data.isActive=='N')?'disabled':''">{{data.menuName}}</a>
                    </div>
                </div>
            </slide>
        </carousel>
    </div>

    <hr>
    <div *ngIf="entityType=='ADMIN' && false">
        <div class="card">
            <div class="row mt-3">
                <div class="col-lg-3 form-group">
                    <label> Member List </label>
                    <select class="form-control form-control selectpicker" title="Select Member" data-live-search="true"
                        (change)="getMemberDetailsDashboard()" [(ngModel)]="selectedMember">

                        <option *ngFor="let data of memberData" value="{{data.entityCode}}">{{data.entityCode +" -
                            "+data.userName}}</option>
                    </select>
                    <!-- <p *ngIf="selectedMember.invalid && memberData.cntrMemId.touched" class="error nocase">
                    Please select Member
                </p> -->
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="dashboardView.length>0 && false"><!-- && entityType=='MEMBER' -->
        <div class="row card ml-4 mr-4">
            <div class="tabs mt-3">
                <div class="row ml-3 tab-list">
                    <div *ngFor="let data of dashboardView" (click)="selectTab(data)" class="ml-2"
                        [class.active]="data == selectedTab">
                        {{data.menuName}}
                    </div>
                </div>
                <!-- <div class="tab-content">
                    <div class="card col-lg-10  shadow1">
                        <h5 class="card-title ml-2 mt-1"> {{selectedTab.menuName}} </h5>
                        <ng-template [ngIf]="selectedTab.menuCode=='pnote'">
                            <div class="row">
                                <div class="col-lg-2 ml-2 mt-1">
                                    <label>Choose Year</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="crntYear"
                                        (change)="getPnoteTradeDataChart(entityCode)">
                                </div>
                                <div class="col-lg-8">
                                    <ng-template [ngIf]="pnoteChartData">
                                        <ngx-charts-bar-vertical-2d [view]="pnoteview" [scheme]="colorScheme"
                                            [results]="pnoteChartData" [gradient]="pnoteChartOption.gradient"
                                            [xAxis]="pnoteChartOption.showXAxis" [yAxis]="pnoteChartOption.showYAxis"
                                            [legend]="pnoteChartOption.showLegend"
                                            [showXAxisLabel]="pnoteChartOption.showXAxisLabel"
                                            [showYAxisLabel]="pnoteChartOption.showYAxisLabel"
                                            [xAxisLabel]="pnoteChartOption.xAxisLabel"
                                            [yAxisLabel]="pnoteChartOption.yAxisLabel"
                                            [animations]="pnoteChartOption.animations" [barPadding]="10"
                                            [groupPadding]="10">
                                        </ngx-charts-bar-vertical-2d>
                                    </ng-template>

                                </div>
                            </div>
                        </ng-template>
                        <ng-template [ngIf]="selectedTab.menuCode=='interestRateSwap'">
                            <ng-template [ngIf]="tradeData">
                                <ngx-charts-advanced-pie-chart [view]="irsView"
                                    [scheme]="irsChartOptions.tradeDetailsColorScheme" [results]="tradeData"
                                    [gradient]="irsChartOptions.gradient" [labels]="irsChartOptions.showLabels"
                                    [doughnut]="irsChartOptions.isDoughnut"
                                    [legendPosistion]="irsChartOptions.legendPosistion" [animations]="true">
                                </ngx-charts-advanced-pie-chart>
                            </ng-template>
                        </ng-template>
                    </div>


                </div> -->
            </div>
        </div>
    </ng-container>
</div>